import { Component, OnInit, Input } from '@angular/core';
import { GlobalService } from '../../../services/global.service';
import { MenuBarService } from './menu-bar.service';
import { SettingsProvider } from '../../../services/settings-provider.service';
import { Router, NavigationEnd, RoutesRecognized } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { Subscription, Observable } from 'rxjs';
import { MessageService } from '../../../services/message.service';
import { TitleModel } from '../../../models/title.model';
import { GraphService } from 'src/app/services/graphs.service';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/pairwise';
@Component({
    selector: 'app-menu-bar',
    templateUrl: './menu-bar.component.html',
    styleUrls: ['./menu-bar.component.css'],
    providers: [MenuBarService],
})
export class MenuBarComponent {

    public appName: string;
    error;
    userData: Array<any>;
    settingData: Array<any> = [];
    userPermissionData: Array<any> = [];
    hideHomeIcon: boolean = true;
    showEditIcon: boolean = false;
    public routerEditLink: string;
    // gOpsUser: boolean = false;
    // gFinUser: boolean = false;
    // gEhsUser: boolean = false;
    permissionsService: Observable<any>;

    private subscribeActivityTitleChange: Subscription;
    public title: TitleModel = { "mainTitle": "Dashboard", "subTitle": "" };

    constructor(public globals: GlobalService,
        private graph: GraphService,
        private messageService: MessageService,
        private settingsProvider: SettingsProvider,
        private router: Router,
        private menuBarService: MenuBarService) {
        this.subscribeActivityTitleChange = this.messageService.getSelectedActivityTitleChangeMessage().subscribe(data => {
            if (data != undefined && data.title != undefined)
                this.title = data.title;
            else
                this.setDefaultTitle();
        });
    }

    setDefaultTitle() {
        this.title.mainTitle = 'Dashboard';
        this.title.subTitle = '';
        if (environment.production == false) {
            this.appName = "Development Version";
        }
        if (this.settingsProvider.configuration.envName != "prod")
            this.title.mainTitle += ' (TEST)';
    }

    ngOnInit() {

        this.permissionsService = this.graph.getPermissions();
        this.permissionsService.subscribe(data => {
            this.globals.opsUser = data.contents.canEditOps;
            this.globals.finUser = data.contents.canEditFin;
            this.globals.hseUser = data.contents.canEditEhs;
            this.showEditIcon = (this.globals.finUser || this.globals.hseUser || this.globals.opsUser);
//            if (this.globals.currentPage == 0 && (this.globals.finUser || this.globals.hseUser || this.globals.opsUser)) {
            if ((this.globals.finUser || this.globals.hseUser || this.globals.opsUser)) {
                this.routerEditLink = "/edit";
            }
        });

        this.setDefaultTitle();

        // Hide/Show home icon
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                let url = event.url;
                if (url == '/') {
                    this.hideHomeIcon = false;
                    this.showEditIcon = (this.globals.finUser || this.globals.hseUser || this.globals.opsUser);
                } else {
                    this.hideHomeIcon = true;
                    this.showEditIcon = false;
                }
            }
        })

        this.menuBarService.getManifest()
            .subscribe(
                (data => {
                    this.appName = data.name;
                }), // success path
                error => {
                    this.error = error // error path
                    console.log('Error Fetching Manifest');
                    console.log(this.error);
                }
            );
        setTimeout(() => {
            this.userData = [{
                actionName: this.globals.user.given_name,
                click: (dataItem) => {
                    this.dialogUser('open');
                }
            }, {
                actionName: 'Logout',
                click: (dataItem) => {
                    this.logOut();
                }
            }];
            this.settingData = [{
                actionName: 'Help',
                click: (dataItem) => {
                    window.open('assets/data/DashboardHelp.pdf', '_blank');
                }
            }]
        });
    }

    //******************************************************* */
    //Kendo dialogs
    //******************************************************* */
    public dialogOpenedUser: boolean = false;
    public dialogOpenedInfo: boolean = false;

    public dialogUser(status) {
        if (status == "open") {
            this.dialogOpenedUser = true;
        } else {
            this.dialogOpenedUser = false;
        }
    }

    public dialogInfo(status) {
        if (status == "open") {
            this.dialogOpenedInfo = true;
        } else {
            this.dialogOpenedInfo = false;
        }
    }
    //******************************************************* */

    public logOut() {
        this.router.navigate(['logout']);
    }
}
